const ServicesData = [
  {
    id: 0,
    service_img: require("../../assets/s1.jpg"),
    service_icon: "fas fa-mortar-pestle fa-fw",
    service_title: "clothes shoes",
    service_text:
      "lorem ipsum dolor sit amet, consect et pur Cumet lorem ipsum dolor sit amet, consect et pur Cumet lorem ipsum dolor sit amet, consect et pur Cumet",
    service_btn: "read more",
  },
  {
    id: 1,
    service_img: require("../../assets/shoes5.jpg"),
    service_icon: "fas fa-home fa-fw",
    service_title: "Home delivery",
    service_text:
      "lorem ipsum dolor sit amet, consect et pur Cumet lorem ipsum dolor sit amet, consect et pur Cumet lorem ipsum dolor sit amet, consect et pur Cumet",
    service_btn: "read more",
  },
  {
    id: 2,
    service_img: require("../../assets/shoes4.jpg"),
    service_icon: "fas fa-mug-hot fa-fw",
    service_title: "sneaker aging",
    service_text:
      "lorem ipsum dolor sit amet, consect et pur Cumet lorem ipsum dolor sit amet, consect et pur Cumet lorem ipsum dolor sit amet, consect et pur Cumet",
    service_btn: "read more",
  },
];

export default ServicesData;
